<template>
  <button :type="type"><slot /></button>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    type: {
      type: String,
      default: "button"
    }
  }
};
</script>

<style scoped>
  button {
    @apply px-4 py-2 rounded bg-blue-500 shadow text-white font-bold;
  }

  button:disabled {
    @apply opacity-50 cursor-default;
  }

  button:not(:disabled):hover {
    @apply bg-blue-700 shadow-none;
  }
</style>
